import { reducers } from 'redux/core'
import request from 'sb-request'

import collectionQuery from './collection.graphql'


/**
 * Fetches collection data
 *
 * @param {Object} params
 * @param {String} params.slug
 * @param {('male'|'female')} params.gender
 *
 * @returns {Promise} request
 */
const fetch = ({ slug, gender }) => {
  reducers.view.collectionPage.setFetched(false)

  return request.post('graphql?name=collection', {
    body: {
      query: collectionQuery,
      variables: {
        slug,
        gender,
      },
    },
    modifyResult: (data) => (data && data.collection || {}),
  })
    .then(
      (collection) => {
        reducers.view.collectionPage.setCollection(collection)

        return collection
      })
}


export default {
  fetch,
}
